import React, { useState, useEffect } from 'react';
import { Modal, Form, Button, Spinner, Row, Col } from 'react-bootstrap';
import { FaEdit, FaCoins, FaHandHoldingUsd, FaNotesMedical } from 'react-icons/fa';
import { toast } from 'react-toastify';
import { budgetApi } from '../../api/budget';
import { handleApiResponse } from '../global/ApiMessageModal/ApiMessageModal';

const HaririBajetiModal = ({ show, onHide, item, onSuccess }) => {
  const [submitting, setSubmitting] = useState(false);
  const [formData, setFormData] = useState({
    service_category_id: '',
    amount: '',
    amount_paid: '',
    new_payment: '',
    description: ''
  });

  useEffect(() => {
    if (item) {
      setFormData({
        service_category_id: item.service_category_id,
        amount: item.amount || '',
        amount_paid: item.amount_paid || 0,
        new_payment: '',
        description: item.description !== '-' ? item.description || '' : ''
      });
    }
  }, [item]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!item?.id) return;
    if (!formData.amount || parseFloat(formData.amount) <= 0) {
      toast.warning('Tafadhali ingiza kiasi sahihi cha bajeti');
      return;
    }

    setSubmitting(true);
    try {
      const currentPaid = parseFloat(formData.amount_paid) || 0;
      const newPayment = parseFloat(formData.new_payment) || 0;
      const totalPaid = currentPaid + newPayment;

      const payload = {
        service_category_id: parseInt(formData.service_category_id),
        amount: parseFloat(formData.amount),
        amount_paid: totalPaid,
        paid_amount: totalPaid,
        paid: totalPaid,
        new_payment: totalPaid,
        description: formData.description || null
      };

      const response = await budgetApi.updateBudget(item.id, payload);
      if (handleApiResponse(response)) {
        toast.success('Bajeti imebadilishwa kikamilifu!');
        onHide();
        if (onSuccess) onSuccess();
      }
    } catch (err) {
      console.error('Error updating budget:', err);
      handleApiResponse(err);
    } finally {
      setSubmitting(false);
    }
  };

  const currentPaidVal = parseFloat(formData.amount_paid) || 0;
  const newPaymentVal = parseFloat(formData.new_payment) || 0;
  const computedTotalPaid = currentPaidVal + newPaymentVal;

  return (
    <Modal show={show} onHide={onHide} size="lg" centered backdrop="static">
      <Modal.Header closeButton className="border-0 pb-0">
        <Modal.Title className="fw-bold d-flex align-items-center gap-2" style={{ color: '#4169e1' }}>
          <div className="p-2 rounded-3 bg-primary-subtle text-primary d-flex align-items-center justify-content-center">
            <FaEdit size={20} />
          </div>
          Hariri Bajeti - {item?.category_name}
        </Modal.Title>
      </Modal.Header>
      <Form onSubmit={handleSubmit}>
        <Modal.Body className="p-4">
          <Form.Group className="mb-3">
            <Form.Label className="fw-semibold">
              <FaCoins className="me-2 text-muted" />
              Kiasi cha Bajeti (TZS) <span className="text-danger">*</span>
            </Form.Label>
            <Form.Control
              type="number"
              step="0.01"
              min="1"
              value={formData.amount}
              onChange={(e) => setFormData({ ...formData, amount: e.target.value })}
              required
              className="rounded-3 shadow-none border py-2"
            />
          </Form.Group>

          <Row>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label className="fw-semibold text-muted">
                  <FaHandHoldingUsd className="me-2 text-muted" />
                  Kiasi Kilicholipwa Sasa (TZS)
                </Form.Label>
                <Form.Control
                  type="number"
                  value={currentPaidVal}
                  readOnly
                  disabled
                  className="bg-light rounded-3 shadow-none border py-2"
                />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label className="fw-semibold">
                  Ongeza Malipo Mapya (TZS)
                </Form.Label>
                <Form.Control
                  type="number"
                  step="0.01"
                  min="0"
                  placeholder="Ingiza malipo mapya"
                  value={formData.new_payment}
                  onChange={(e) => setFormData({ ...formData, new_payment: e.target.value })}
                  className="rounded-3 shadow-none border py-2"
                />
                <Form.Text className="text-muted small">
                  Jumla Mpya ya Malipo: <strong>TZS {computedTotalPaid.toLocaleString()}</strong>
                </Form.Text>
              </Form.Group>
            </Col>
          </Row>

          <Form.Group className="mb-3">
            <Form.Label className="fw-semibold">
              <FaNotesMedical className="me-2 text-muted" />
              Maelezo (Description)
            </Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              value={formData.description}
              onChange={(e) => setFormData({ ...formData, description: e.target.value })}
              className="rounded-3 shadow-none border"
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer className="border-0 pt-0 px-4 pb-4">
          <Button variant="light" onClick={onHide} className="rounded-pill px-4 fw-medium border">
            Ghairi
          </Button>
          <Button
            type="submit"
            variant="primary"
            disabled={submitting}
            className="rounded-pill px-4 fw-semibold shadow-sm border-0"
            style={{ backgroundColor: '#4169e1' }}
          >
            {submitting ? (
              <><Spinner animation="border" size="sm" className="me-2" />Inahifadhi...</>
            ) : (
              'Hifadhi Mabadiliko'
            )}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default HaririBajetiModal;
